/*global moment*/
import { getTemplate } from "../template-helper";
import { save, getSavePatch, prepareOccurrenceSubElements, runInContext, deleteRecord, bind, rebasePath, prepareElementsToBind } from "../binding";

import Mustache from "mustache";
import { tr } from "../../util/locales";
import { getZGridDefaultEditor, getZGridRichTextEditor, getZGridMediaEditor, getZGridBinaryEditor, getZGridCodeHtmlEditor, getZGridComposeHtmlEditor, getZGridTooltip, createColDefFromSchema} from "../../util/z-grid-helper";
import { upgradeCache } from "../../util/formatter";
import { uuidv4 } from "../../util/utils";


const COMPONENT_NAME = "z-grid" ;

const TEMPLATE_ID = "component-"+COMPONENT_NAME+"-template" ;
const TEMPLATE_URL = "/static/libs/components/"+COMPONENT_NAME+".html" ;



export default function register(){
    getTemplate(TEMPLATE_ID, TEMPLATE_URL).then((template)=>{
        class GridColComponent extends HTMLElement {
            constructor() {
                super();
                if(this.innerHTML && !this.innerHTML.startsWith("<!--") && !this.innerHTML.endsWith("-->")){
                    this.innerHTML = `<!--${this.innerHTML}-->` ;
                }
            }

            connectedCallback(){
            }
        }

        class GridMobileRenderComponent extends HTMLElement {
            constructor() {
                super();
                if(this.innerHTML && !this.innerHTML.startsWith("<!--") && !this.innerHTML.endsWith("-->")){
                    this.innerHTML = `<!--${this.innerHTML}-->` ;
                }
            }

            connectedCallback(){
            }
        }
            
        class GridComponent extends HTMLElement {
            constructor() {
                super();

                //allow value to be an array
                this.isArrayContainer = true ;

                //prevent inner change and keyup to bubble outside the grid
                //because it made the binding system receive change twice from the
                //inner field and the grid field
                this.addEventListener("change", (ev)=>{
                    if(ev.target !== this){
                        ev.preventDefault();
                        ev.stopPropagation();
                    }
                }) ;
                this.addEventListener("keyup", (ev)=>{
                    if(ev.target !== this){
                        ev.preventDefault();
                        ev.stopPropagation();
                    }
                }) ;
            }

            connectedCallback(){
                this.init() ;
            }

            saveEditingCell(){
                
            }

            init(){
                if(this.initDone){ return Promise.resolve();}
                this.initDone = true ;

                this.style.display = "block";

                

                const existingGrid = this.querySelector(".z-grid-container") ;
                if(existingGrid){
                    this.removeChild(existingGrid) ;
                }

                const clone = document.importNode(template.content, true);
                this.appendChild(clone);

                let themeName = this.getAttribute("z-theme") ;
                if(!themeName){
                    themeName = "alpine" ;
                }
                const container = this.querySelector(".ag-grid-div") ;
                let themeMode = window.APP&&window.APP.theme_mode?window.APP.theme_mode:"light" ;
                if(themeMode==="dark"){
                    container.classList.add("ag-theme-"+themeName+"-dark");
                    container.classList.remove("ag-theme-"+themeName);
                }else{
                    container.classList.add("ag-theme-"+themeName);
                    container.classList.remove("ag-theme-"+themeName+"-dark");
                }

                let rowClassRules = {
                    // row style function
                    'z-grid-edit-new-line': function(params) {
                      return params.data && params.data.__isNewLine;
                    }
                } ;

                for(let a = 0; a<this.attributes.length; a++){
                    let att = this.attributes[a] ;
                    if(/^z-row-class-rule-/.test(att.name)){
                        let className = att.name.replace(/^z-row-class-rule-/, "") ;
                        rowClassRules[className] = (params)=>{
                            return runInContext(this, {params}, att.value) ;
                        } ;
                    }
                }

                let gridOptions = {
                    columnDefs: [],
                    rowSelection: this.getAttribute("z-row-selection")||'single',
                    rowDragManaged: true,
                    //animateRows: this.editable,
                    singleClickEdit: true,
                    stopEditingWhenGridLosesFocus: true,
                    enableCellChangeFlash: true,
                    tooltipShowDelay: 0,
                    defaultColDef: {
                        sortable: true,
                        filter: true,
                        resizable: true,
                        tooltipComponent: 'zGridTooltip'
                    },
                    suppressCellSelection: true,
                    rowClassRules: rowClassRules,
                    localeTextFunc: function(key, defaultValue) {
                        const trKey = 'aggrid.' + key;
                        const translatedValue = tr(trKey);
                        if(translatedValue === trKey){
                            console.warn("missing ag grid tr key "+trKey, defaultValue) ;
                        }
                        return translatedValue === trKey ? defaultValue : translatedValue;
                    },
                    components: {
                        zGridDefaultEditor: getZGridDefaultEditor(),
                        zGridTooltip: getZGridTooltip(),
                        zGridRichTextEditor: getZGridRichTextEditor(),
                        zGridMediaEditor: getZGridMediaEditor(),
                        zGridBinaryEditor: getZGridBinaryEditor(),
                        zGridCodeHtmlEditor: getZGridCodeHtmlEditor(),
                        zGridComposeHtmlEditor: getZGridComposeHtmlEditor()
                    },
                    onRowDoubleClicked: (ev)=>{
                        this.dispatchEvent(new CustomEvent("rowdoubleclick", { bubbles: true, detail: ev.data})) ;
                        this.onRowDoubleClicked(ev.data) ;
                    },
                    onRowClicked: (ev)=>{
                        if(this.isMobileDisplay()){
                            this.onRowDoubleClicked(ev.data) ;
                        }else{
                            this.dispatchEvent(new CustomEvent("rowclick", { bubbles: true, detail: ev.data})) ;
                        }
                    },
                    onCellEditingStopped: async (event)=> {
                        if(event.colDef.cellEditorParams && event.colDef.cellEditorParams.zType === "one2many"){
                            return; //save of one2many is not handled here
                        }
                        if(event.newValue === event.oldValue){
                            return; //no limit
                        }
                        let fieldId = "_id" ;
                        if(this.hasAttribute("z-field-id")){
                            fieldId = this.getAttribute("z-field-id") ;
                        }
                        if(event.value){
                            if(event.data.__isNewLine){
                                let colContainer = this.querySelector('.ag-center-cols-container [row-id="'+event.node.id+'"]');
                                let pinnedContainer = this.querySelector('.ag-pinned-left-cols-container [row-id="'+event.node.id+'"]');
                                if(colContainer){
                                    colContainer.classList.remove("z-grid-edit-new-line") ;
                                }
                                if(pinnedContainer){
                                    pinnedContainer.classList.remove("z-grid-edit-new-line") ;
                                }
                                delete event.data.__isNewLine ;
                            }
                        }
                        if(this.autoSave){
                            let modifiedData = {} ;
                            modifiedData[event.column.colId] = event.newValue ;
                            let url = this.getAttribute("z-save-url") ;
                            if(!url){
                                url = this.getAttribute("z-bind-url") ;
                            }
                            let id = event.data[fieldId] ; 
                            if(id){
                                if(url[url.length-1] !== "/"){
                                    url += "/" ;
                                }
                                url = url + id ;
                            }
                            let dataOrig = JSON.parse(JSON.stringify(event.data)) ;
                            dataOrig[event.column.colId] = event.oldValue ;
                            const dataPatch = {
                                id: id,
                                data: event.data,
                                dataOrig: dataOrig,
                                dataPatch: modifiedData,
                                url: url,
                            } ; //getSavePatch(this, fieldId, this.data.indexOf(event.data)) ;
                            if(dataPatch.dataPatch){
                                //this edition has modif to save
                                await save(dataPatch, fieldId) ;
                            }
                        }

                        if(event.value){
                            let rowCount = this.rowCount ;
                            if(this.data){
                                rowCount = this.data.length ;
                            }
                            if(event.rowIndex === rowCount-1){
                                this.addNewEditRecord() ;
                            }
                        }
                    },
                    onRowDragEnd: (event)=>{
                        const movedRow = event.node.data ; 
                        this.data.__stopAutoBind = true;
                        let indexStart = this.data.indexOf(movedRow) ;
                        if(indexStart<event.overIndex){
                            this.data.splice(indexStart, 1) ;    
                            this.data.splice(event.overIndex,0,movedRow) ;
                        }else{
                            this.data.splice(event.overIndex,0,movedRow) ;
                            this.data.splice(indexStart+1, 1) ;    
                        }
                        this.data.__stopAutoBind = false;

                        const model = this.getAttribute("z-model")  ;
                        if(this.autoSave && model){
                            let fieldId = "_id" ;
                            if(this.hasAttribute("z-field-id")){
                                fieldId = this.getAttribute("z-field-id") ;
                            }
                            const allLines = this.data ;
                            const modifiedLines = [] ;
                            for(let i=0; i<allLines.length; i++){
                                if(allLines[i][fieldId] && allLines[i]._index !== i+1 ){
                                    allLines[i]._index = i+1 ;
                                    modifiedLines.push(allLines[i]) ;
                                }
                            }
                            let restApi = window.restApi;
                            if(this.hasAttribute("z-app")){
                                restApi = window.getRestApi(this.getAttribute("z-app")) ;
                            }
                            restApi.update(modifiedLines.map(m=>{
                                return {
                                    table: model,
                                    action: "update",
                                    id: m[fieldId],
                                    record: {_index: m._index},
                                };
                            })).then(()=>{
                                this.notifyChange() ;
                            });
                        }
                    },
                    onCellKeyDown: ev=>{
                        if(ev.event.keyCode === 46 && !this.editable){
                            this.dispatchEvent(new CustomEvent("deleteRows", { bubbles: true, detail: this.gridOptions.api.getSelectedNodes().map(n=>n.data)})) ;
                        }
                    },
                    onSortChanged: (ev)=>{ this.colStateChanged(ev) ; },
                    onFilterChanged: (ev)=>{ this.colStateChanged(ev) ; },
                    onColumnResized: (ev)=>{ this.colStateChanged(ev) ; },
                    onColumnVisible: (ev)=>{ this.colStateChanged(ev) ; },
                    onColumnPivotChanged: (ev)=>{ this.colStateChanged(ev) ; },
                    onColumnRowGroupChanged: (ev)=>{ this.colStateChanged(ev) ; },
                    onColumnValueChanged: (ev)=>{ this.colStateChanged(ev) ; },
                    onColumnMoved: (ev)=>{ this.colStateChanged(ev) ; },
                    onColumnPinned: (ev)=>{ this.colStateChanged(ev) ; },
                    onGridReady:()=>{
                        if(this.initialState){
                            this.applyState(this.initialState) ;
                        }
                    },
                    onFirstDataRendered:()=>{
                        if(this.initialFilter){
                            this.applyFilter(this.initialFilter) ;
                        }
                    }
                } ;
                if(this.hasAttribute("z-data-source")){
                    let dataSourceValue = this.getAttribute("z-data-source") ;
                    try{
                        gridOptions.rowModelType = 'infinite' ;
                        gridOptions.datasource = runInContext(this, {}, dataSourceValue.replace("func:", "")) ;
                        gridOptions.getRowId = function(params) {
                            // the ID can be any string, as long as it's unique within your dataset
                            return params.data.__new_id || params.data._id || params.data.id ;
                        } ;
                    }catch(err){
                        console.error("Error while running ", dataSourceValue, err);
                    }
                }else if(this.hasAttribute("z-server-side") && this.getAttribute("z-server-side") !== "false"){
                    if(this.hasAttribute("z-model")){
                        let search = {} ;
                        if(this.hasAttribute("z-server-search")){
                            search.where = this.getAttribute("z-server-search").split("/") ;
                        }
                        if(this.hasAttribute("z-server-orderby")){
                            search.orderby = this.getAttribute("z-server-orderby").split(",") ;
                        }
                        gridOptions.rowModelType = 'infinite' ;
                        gridOptions.datasource = this.createDataSource(this.getAttribute("z-model"), search) ;
                    }
                }
                if(this.getAttribute("z-components")) {
                    let components = this.getAttribute("z-components") ;
                    if(components[0] === "["){
                        components = JSON.parse(components) ;
                    }else{
                        try{
                            components = runInContext(this, {}, components) ;
                        }catch(err){
                            console.error("Error while running ", components, err);
                        }
                    }
                    components.forEach(c => {
                        gridOptions.components[c.name] = c.editor ;
                    }) ;
                }


                const elMobileRender = this.querySelector("z-mobile-render") ;
                if(elMobileRender){
                    if(!gridOptions.components){ gridOptions.components = {} ; }

                    const self = this ;
                    const mobileHtml = elMobileRender.innerHTML.replace(/^<!--/, "").replace(/-->$/, "").trim() ;
                    class MobileFullWidthCellViewRenderer {
                        constructor() { }
                        init(params) {
                            if(!this.elCell){
                                this.elCell = document.createElement('div');
                            }else{
                                this.elCell.removeAttribute("zz-bind-prepared") ;
                                delete this.elCell.__zzBindPrepared ;
                            }
                            
                            setTimeout(()=>{
                                this.elCell.innerHTML = mobileHtml;
                                //set timeout so it will be inserted in DOM before bind
                                prepareElementsToBind(this.elCell) ;

                                this.indexInData = self.data.indexOf(params.data) ;

                                let gridZBind = self.getAttribute("z-bind") ;
                                if(gridZBind[0]=="{"){
                                    gridZBind = JSON.parse(gridZBind)._value ;
                                }
                                if(elMobileRender.getAttribute("z-bind-scope") !== "global"){
                                    rebasePath(this.elCell, gridZBind) ;
                                }
                                this.elCell.setAttribute("zz-instance-el", "mobileFullWithRender") ;
                                prepareOccurrenceSubElements(this.elCell, gridZBind, this.indexInData) ;
                                this.elCell.addEventListener("bindStart", ()=>{
                                    this.elCell.getData = function(){ return params.data ;} ;
                                }) ;
                                
                                
                                bind(this.elCell, self.getRootNode().getData(), null, null, true);
                            }, 1);
                        }
                        getGui() {
                            return this.elCell;
                        }
                        refresh(params) {
                            this.elCell.innerHTML = mobileHtml;
                            this.elCell.removeAttribute("zz-bind-prepared") ;
                            delete this.elCell.__zzBindPrepared ;

                            prepareElementsToBind(this.elCell) ;

                            let gridZBind = self.getAttribute("z-bind") ;
                            if(gridZBind[0]=="{"){
                                gridZBind = JSON.parse(gridZBind)._value ;
                            }
                            if(elMobileRender.getAttribute("z-bind-scope") !== "global"){
                                rebasePath(this.elCell, gridZBind) ;
                            }
                            this.elCell.setAttribute("zz-instance-el", "mobileFullWithRender") ;
                            prepareOccurrenceSubElements(this.elCell, gridZBind, this.indexInData) ;
                            this.elCell.addEventListener("bindStart", ()=>{
                                this.elCell.getData = function(){ return params.data ;} ;
                            }) ;
                            bind(this.elCell, self.getRootNode().getData(), null, null, true);
                            return true;
                        }
                        destroy() {
                        }
                    }

                    gridOptions.components.mobileFullWithRender = MobileFullWidthCellViewRenderer;
                    gridOptions.isFullWidthCell = (rowNode) => {
                        if(this.isMobileDisplay()){
                            return !!mobileRowHeight ;
                        }
                    } ;
                    gridOptions.fullWidthCellRenderer = 'mobileFullWithRender' ;
                    const mobileRowHeight = Number(elMobileRender.getAttribute("height")||100) ;
                    gridOptions.getRowHeight = (params) => {
                        if(this.isMobileDisplay()){
                            return mobileRowHeight ;
                        }else if(gridOptions.rowHeight){
                            return Number(gridOptions.rowHeight) ;
                        }
                    } ;
                }

                let attrs = this.attributes ;
                for(let attr of attrs){
                    if(/^z-grid-option-/.test(attr.name)){
                        let optName = attr.name.replace(/^z-grid-option-/, "").split("-").map((v, i)=>{
                            if(i>0){
                                return v.substring(0,1).toUpperCase()+v.substring(1) ;
                            }else{
                                return v ;
                            }
                        }).join("") ;
                        let value = attr.value ;
                        if(value === "true"){ 
                            value = true ; 
                        }else if(value === "false"){ 
                            value = false ; 
                        }else if(value && 
                            (
                                (value[0] === "{" && value[value.length -1]=== "}") ||
                                (value[0] === "[" && value[value.length -1]=== "]") 
                            )){
                                try{
                                    value = JSON.parse(value) ;
                                }catch(e){
                                    console.error("WRONG VALUE "+value, e) ;
                                }
                        }else if(value === ""+Number(value)){
                            value = Number(value) ;
                        }
                        if(value.indexOf && value.indexOf("func:") === 0){
                            try{
                                value = runInContext(this, {}, value.replace("func:", "")) ;
                            }catch(err){
                                console.error("Error while running ", value, err);
                            }
                        }
                        const optPath = optName.split(".") ;
                        let optObject = gridOptions;
                        while(optPath.length>1){
                            const p = optPath.shift() ;
                            if(!optObject[p]){
                                optObject[p] = {} ;
                            }
                            optObject = optObject[p] ;
                        }
                        optObject[optPath.shift()] = value ;
                    }
                }

                this.gridOptions = gridOptions;

                

                return this.createColumnsDef().then((columnDefs)=>{
                    if(elMobileRender && this.isMobileDisplay()){
                        //in mobile full width mode, display first col only as we display full width row
                        for(let i=1; i<columnDefs.length; i++){
                            columnDefs[i].hide = true;
                        }
                        this.classList.add("mobile-mode") ;
                    }else{
                        this.classList.remove("mobile-mode") ;
                    }

                    gridOptions.columnDefs = columnDefs ;

                    
                    
                    if(this.data){
                        gridOptions.rowData = this.data ;
                    }
                    new window.agGrid.Grid(container, gridOptions);

                    

                    if(this.listeners){
                        Object.keys(this.listeners).forEach((event)=>{
                            for(let callback of this.listeners[event]){
                                gridOptions.api.addEventListener(event, callback);
                            }
                        }) ;
                    }

                    // if(this.editable){
                    //     this.setEditable(true) ;
                    // }
                }) ;
            }

            isMobileDisplay(){
                return window.innerWidth<1024 || this.hasAttribute("z-force-mobile-render") ;
            }

            refreshServerSide(){
                this.gridOptions.api.refreshInfiniteCache() ;
            }

            createDataSource(model, searchParam){
                let self = this ;
                const datasource = {
                    async getRows(params) {
                        let table_name = model;
                        let search = {};
                        if(searchParam){
                            search = JSON.parse(JSON.stringify(searchParam)) ;
                        }
                        let startRow = params.startRow;
                        let endRow = params.endRow;
                        

                        search.limit = endRow - startRow + 1 ;
                        search.offset = startRow ; 
                        if(!search.joins){
                            search.joins = [] ;   
                        }
                        if(!search.where){
                            search.where = [] ;   
                        }
                        if(!search.orderby){
                            search.orderby = [] ;   
                        }

                        let filterModel = params.filterModel;

                        let schema = window.APP.schema ;
                        if(self.hasAttribute("z-app")){
                            if(window.APPS[self.getAttribute("z-app")]){
                                schema = window.APPS[self.getAttribute("z-app")].schema ;
                            }
                        }
                        const modelDef = schema.models.find(m => m.name === model) ;

                        if(!modelDef){
                            return params.failCallback("unkown model "+model);
                        }
                        
                        if(filterModel && modelDef){
                            Object.keys(filterModel).forEach(field => {
                                let whereFilter = [] ;

                                let filter = filterModel[field] ;
                                let columnDef = modelDef.columns.find(c => c.name === field);

                                let searchedColumns = [columnDef.name] ;
                    
                                function createSearch(filterCondition){
                                    if(searchedColumns.length===1){
                                        return createOneSearch(filterCondition, searchedColumns[0]) ;
                                    }else{
                                        return ["or("].concat(
                                            searchedColumns.map(s=>createOneSearch(filterCondition, s))) 
                                            .concat([")"]);
                                    }
                                }
                                function createOneSearch(filterCondition, columnName){
                                    let operators = {
                                        greaterThan: "gt",
                                        greaterThanOrEqual: "gte",
                                        lessThan: "lt",
                                        lessThanOrEqual: "lte",
                                    } ;
                                    let filterType = filterCondition.type||filterCondition.filterType ;
                                    switch(filterType){
                                        case 'set':
                                            if(["boolean", "selection"].includes(columnDef.type)){
                                                return [columnName+" in "+ filterCondition.values.map(v => {
                                                    if(columnDef.type === "boolean"){
                                                        return v === tr("global.yes");
                                                    }else if(columnDef.type === "selection"&& columnDef.values){
                                                        for(var i=0; i<columnDef.values.length; i++){
                                                            if(v === tr("fields.values."+table_name+"."+columnDef.name+"."+columnDef.values[i])){
                                                                return columnDef.values[i] ;
                                                            }
                                                        }
                                                    }
                                                })] ;
                                            }else{ 
                                                //type search
                                                let valuesChosen = filterCondition.values.map(f=>{
                                                    let strId = f.substring(f.lastIndexOf("__")+2, f.indexOf(",")) ;
                                                    if(strId === "NULL"){
                                                        return null;
                                                    }else{
                                                        return Number(strId) ;
                                                    }
                                                }) ;
                                                let hasNull = valuesChosen.some(v=>v===null) ;
                                                if(hasNull){
                                                    let valuesNotNull = valuesChosen.filter(v=>v!==null) ;
                                                    if(valuesNotNull.length>0){
                                                        return ["or(", columnDef.name+" isnull", columnDef.name+" in "+valuesNotNull.join(","), ")"] ;
                                                    }else{
                                                        return columnDef.name+" isnull" ;
                                                    }
                                                }else{
                                                    return columnDef.name+" in "+valuesChosen.join(",") ;
                                                }
                                            }
                                        case 'contains':
                                        case 'text':
                                            return [columnName+" ilike %"+filterCondition.filter+"%"];                                        
                                        case 'notContains':
                                            return [columnName+" notLike %"+filterCondition.filter+"%"];
                                        case 'equals':
                                            if(filter.filterType === "date"){
                                                return [columnName + " between "+filterCondition.dateFrom+","+moment(filterCondition.dateFrom).endOf("day").format("YYYY-MM-DD HH:mm:ss.SSS")] ;
                                            }else{
                                                return [columnName + " = "+filterCondition.filter] ;
                                            }
                                        case 'notEqual':
                                            return [columnName + " ne "+filterCondition.filter] ;
                                        case 'startsWith':
                                            return [columnName+" ilike "+filterCondition.filter+"%"];
                                        case 'endsWith':
                                            return [columnName+" ilike %"+filterCondition.filter];
                                        case 'greaterThan':
                                        case 'greaterThanOrEqual':
                                        case 'lessThan':
                                        case 'lessThanOrEqual':
                                            if(filter.filterType === "date"){
                                                return [columnName+" "+operators[filterType]+" "+filterCondition.dateFrom];
                                            }else{
                                                return [columnName+" "+operators[filterType]+" "+filterCondition.filter];
                                            }
                                        case 'inRange':
                                            if(filter.filterType === "date"){
                                                return [columnName+" between "+filterCondition.dateFrom+","+filterCondition.dateTo];
                                            }else{
                                                return [columnName+" between "+filterCondition.filter+","+filterCondition.filterTo];
                                            }
                                        case 'blank':
                                            if(["string", "phone", "email", "password", "color", "textarea", "html", "compose-html", "code-html"].includes(columnDef.type)){
                                                return ["or(", columnName+" isnull",columnName+"=", ")"] ;
                                            }else{
                                                return [columnName+" isnull"] ;
                                            }
                                        case 'notBlank':
                                            if(["string", "phone", "email", "password", "color", "textarea", "html", "compose-html", "code-html"].includes(columnDef.type)){
                                                return ["or(", columnName+" isnotnull",columnName+" ne ", ")"] ;
                                            }else{
                                                return [columnName+" isnotnull"] ;
                                            }
                                        default:
                                            throw new Error("filter type "+filterType+" unexpected");
                                    } 
                                }
                    
                                if(columnDef.type === "search" || field.type === "reference" || field.type === "user"){
                                    // reference column, add join and search on sub table
                                    const targetModel = schema.models.find(m => m.name === columnDef.references.model) ;
            
                                    searchedColumns = columnDef.references.searchedColumns ;
                                    if(!searchedColumns){
                                        if(columnDef.references.label.indexOf("{{") !== -1){
                                            searchedColumns = [] ;
                                            const extractResult = columnDef.references.label.match(/{{([^}]+)}}/g) ;
                                            if(extractResult){
                                                for(let r=0; r<extractResult.length; r++){
                                                    searchedColumns.push(extractResult[r].replace(/^{{/, "").replace(/}}$/, "")) ;
                                                }
                                            }
                                        }else{
                                            searchedColumns = [columnDef.references.label.trim()] ;
                                        }
                                    }

                                    if(targetModel){
                                        searchedColumns = searchedColumns.filter(col=>{
                                            let foundCol = targetModel.columns.find(c=>c.name===col) ;
                                            return foundCol && foundCol.type === "string" ;
                                        }) ;
                                    }
                                    let joinCol = {
                                        otherTable: targetModel.name,
                                        on: columnDef.name,
                                        one: true,
                                        as: "join_"+columnDef.name
                                    } ;
                                    search.joins.push(joinCol) ;
                                    searchedColumns = searchedColumns.map(s=>joinCol.as+"."+s) ;
                                }

                                if(filter.operator === "AND" || filter.operator === "OR"){
                                    whereFilter = [ 
                                        filter.operator.toLowerCase()+"(",
                                        createSearch(filter.condition1),
                                        createSearch(filter.condition2),
                                        ")"
                                    ] ;
                                }else{
                                    whereFilter = [createSearch(filter)] ;
                                }

                                search.where=search.where.concat(whereFilter) ;
                            });
                        }

                        let sortModel = params.sortModel;
                        if(sortModel && sortModel.length > 0){
                            search.orderby = [] ;
                            for(let s of sortModel){
                                let columnDef = modelDef.columns.find(c => c.name === s.colId);
                                if(!columnDef){ continue ; }

                                if(!columnDef.reference){
                                    search.orderby.push( "t."+s.colId + " " + s.sort ); 
                                }else{
                                    
                                    let alreadyJoin = search.joins.some(j => j.name === "join_"+columnDef.name) ;
                                    if(!alreadyJoin){
                                        const targetModel = schema.models.find(m => m.name === columnDef.references.model) ;
                                        let joinCol = {
                                            otherTable: targetModel.name,
                                            on: columnDef.name,
                                            one: true,
                                            as: "join_"+columnDef.name
                                        } ;
                                        search.joins.push(joinCol) ;
                                    }
                                    search.orderby.push( "join_"+columnDef.name+"."+s.colId + " " + s.sort ); 
                                }
                            }
                        }else if(search.orderby.length === 0){
                            search.orderby = "t._index desc" ;
                        }

                        let restApi = window.getRestApi(self.getAttribute("z-app"));
                        let searchCount = JSON.parse(JSON.stringify(search)) ;
                        searchCount.select = "count t._id" ;
                        delete searchCount.orderby ;
                        delete searchCount.limit ;
                        delete searchCount.offset ;
                        try{
                            let resultCount = await restApi.search(table_name, searchCount) ;
                            let rowCount = Number(resultCount[0].count) ;
                            let results = [] ;
                            if(rowCount>0){
                                results = await restApi.search(table_name, search) ;
                            }
                            if(self.editable && !self.noNewLineAuto && endRow >= rowCount){
                                // __new_id is to ensure it has a unique agrid inner id (used in getRowId)
                                let newRecord = { description: "the new", __isNewLine : true, __new_id: uuidv4() } ;
                                rowCount++ ;
                                results.push(newRecord) ;
                            }
                            self.rowCount = rowCount ;
                            params.successCallback(results, rowCount);
                        }catch(err){
                            params.failCallback(err);
                        }

                    }
                };
                return datasource ;
            }


            createColumnsDef(){
                const allColumns = Array.prototype.slice.apply(this.querySelectorAll("z-col")) ;

                let promiseColumns = Promise.resolve();
                if(this.hasAttribute("z-col-def")){
                    const attrColDef = this.getAttribute("z-col-def") ;
                    let columnsDef ;
                    if(attrColDef[0] === "["){
                        columnsDef = JSON.parse(attrColDef) ;
                    }else{
                        try{
                            columnsDef = runInContext(this, {}, attrColDef.replace("func:", "")) ;
                        }catch(err){
                            console.error("Error while running ", attrColDef, err);
                        }
                    }
                    if(!columnsDef){
                        console.error("Missing function or array "+attrColDef) ;
                    }
                    if(typeof(columnsDef) === "function"){
                        const columnDefResult = columnsDef() ;
                        if(columnDefResult && columnDefResult.constructor === Promise){
                            promiseColumns = columnDefResult ;
                        }else{
                            promiseColumns = Promise.resolve(columnDefResult) ;
                        }
                    }else{
                        promiseColumns = Promise.resolve(columnsDef) ;
                    }
                }else if(allColumns.length === 0 && this.hasAttribute("z-model")){
                    const model = this.getAttribute("z-model")  ;
                    let schema = window.APP.schema ;
                    if(this.hasAttribute("z-app")){
                        if(window.APPS[this.getAttribute("z-app")]){
                            schema = window.APPS[this.getAttribute("z-app")].schema ;
                        }
                    }
                    const modelDef = schema.models.find(m => m.name === model) ;
                    if(modelDef){
                        const columnDefs = modelDef.columns.map((c)=> { 
                            const colDef = createColDefFromSchema(modelDef.name+"."+c.name, this.getAttribute("z-app")) ;
                            colDef.editable = true;
                            if(c.name[0] === "_"){
                                colDef.hide = true ;
                            }
                            return colDef ;
                        }) ;
                        promiseColumns = Promise.resolve(columnDefs) ;
                    }
                }else{
                    const columnDefs = [] ;

                    const allColumnsEditables = this.hasAttribute("z-editable") && !allColumns.some(c=>c.hasAttribute("z-editable")||c.hasAttribute("ag-editable") ) ;

                    for(let i=0; i<allColumns.length; i++){
                        const colEl = allColumns[i] ;
                        let columnDef = {} ;
                        if(colEl.hasAttribute("z-model")){
                            columnDef = createColDefFromSchema(colEl.getAttribute("z-model"), this.getAttribute("z-app")) ;
                        }
                        const colHtml = colEl.innerHTML.replace(/^<!--/, "").replace(/-->$/, "").trim() ;

                        if(colHtml){
                            colEl.style.display = "none" ;
                            if(!columnDef.field){
                                columnDef.field = "_id" ;
                            }
                            const colUid = uuidv4() ;
                            const self = this ;
                            class CellViewRenderer {
                                constructor() { }
                                init(params) {
                                    if(!this.elCell){
                                        this.elCell = document.createElement('div');
                                    }else{
                                        this.elCell.removeAttribute("zz-bind-prepared") ;
                                        delete this.elCell.__zzBindPrepared ;
                                    }
                                    
                                    setTimeout(()=>{
                                        this.elCell.innerHTML = colHtml;
                                        //set timeout so it will be inserted in DOM before bind
                                        prepareElementsToBind(this.elCell) ;

                                        this.indexInData = self.data.indexOf(params.data) ;

                                        let gridZBind = self.getAttribute("z-bind") ;
                                        if(gridZBind[0]=="{"){
                                            gridZBind = JSON.parse(gridZBind)._value ;
                                        }
                                        if(colEl.getAttribute("z-bind-scope") !== "global"){
                                            rebasePath(this.elCell, gridZBind) ;
                                        }
                                        this.elCell.setAttribute("zz-instance-el", colUid) ;
                                        prepareOccurrenceSubElements(this.elCell, gridZBind, this.indexInData) ;
                                        this.elCell.addEventListener("bindStart", ()=>{
                                            this.elCell.getData = function(){ return params.data ;} ;
                                        }) ;
                                        
                                        
                                        bind(this.elCell, self.getRootNode().getData(), null, null, true);
                                    }, 1);
                                }
                                getGui() {
                                    return this.elCell;
                                }
                                refresh(params) {
                                    this.elCell.innerHTML = colHtml;
                                    this.elCell.removeAttribute("zz-bind-prepared") ;
                                    delete this.elCell.__zzBindPrepared ;

                                    prepareElementsToBind(this.elCell) ;

                                    let gridZBind = self.getAttribute("z-bind") ;
                                    if(gridZBind[0]=="{"){
                                        gridZBind = JSON.parse(gridZBind)._value ;
                                    }
                                    if(colEl.getAttribute("z-bind-scope") !== "global"){
                                        rebasePath(this.elCell, gridZBind) ;
                                    }
                                    this.elCell.setAttribute("zz-instance-el", colUid) ;
                                    prepareOccurrenceSubElements(this.elCell, gridZBind, this.indexInData) ;
                                    this.elCell.addEventListener("bindStart", ()=>{
                                        this.elCell.getData = function(){ return params.data ;} ;
                                    }) ;
                                    bind(this.elCell, self.getRootNode().getData(), null, null, true);
                                    return true;
                                }
                                destroy() {
                                }
                            }

                            this.gridOptions.components[colUid] = CellViewRenderer;
                            columnDef.cellRenderer = colUid ;
                        }
                        for (let i = 0; i < colEl.attributes.length; i++) {
                            const attr = colEl.attributes[i];
                            if(attr.name.indexOf("ag-") === 0){
                                let agName = attr.name[3] ;
                                for(let c = 4; c<attr.name.length; c++){
                                    if(attr.name[c] === "-"){
                                        agName += attr.name[++c].toUpperCase() ;
                                    }else{
                                        agName += attr.name[c] ;
                                    }
                                }
                                if(["sortable"].includes(agName)){
                                    columnDef[agName] = true ;
                                }else{
                                    let value = attr.value ;
                                    if(value === "true"){ 
                                        value = true ; 
                                    }else if(value === "false"){ 
                                        value = false ; 
                                    }else if(attr.value.indexOf && attr.value.indexOf("func:") === 0){
                                        try{
                                            value = runInContext(this, {}, attr.value.replace("func:", "")) ;
                                        }catch(err){
                                            console.error("Error while running ", attr.value, err);
                                        }
                                    }
                                    columnDef[agName] = value ;
                                }
                            }
                        }
                        if(allColumnsEditables){
                            columnDef.editable = true ;
                        }else if(colEl.hasAttribute("z-editable")){
                            columnDef.editable = true ;
                        }

                        
                        columnDefs.push(columnDef) ;
                    }
                    promiseColumns = Promise.resolve(columnDefs) ;
                }
                return promiseColumns.then((columnDefs)=>{
                    let finalColumnsDefs = null ;
                    if(columnDefs){
                        finalColumnsDefs = [] ;
                        for(let i=0; i<columnDefs.length; i++){
                            const finalColumnDef = {} ;
                            const colDef = columnDefs[i] ; 
                            Object.keys(colDef).forEach((k)=>{
                                finalColumnDef[k] = colDef[k] ;
                            }) ;
                            if(!finalColumnDef.colId){
                                finalColumnDef.colId = finalColumnDef.field||"col_"+i ;
                            }
                            if(finalColumnDef.editable){
                                if(!this.editable){
                                    //not editable mode
                                    delete finalColumnDef.editable ;
                                }else{
                                    //edition mode
                                    finalColumnDef.sortable = false ;
                                    if(finalColumnDef.cellEditorParams && finalColumnDef.cellEditorParams.zType){
                                        switch (finalColumnDef.cellEditorParams.zType) {
                                            case "html":
                                                finalColumnDef.cellEditor = 'zGridRichTextEditor';
                                                break;
                                            case "code-html":
                                                finalColumnDef.cellEditor = "zGridCodeHtmlEditor";
                                                break;
                                            case "compose-html":
                                                finalColumnDef.cellEditor = "zGridComposeHtmlEditor";
                                                break;
                                            case "media":
                                                finalColumnDef.cellEditor = 'zGridMediaEditor';
                                                break;
                                            case "binary":
                                                finalColumnDef.cellEditor = 'zGridBinaryEditor';
                                                break;
                                            case "textarea":
                                                finalColumnDef.cellEditor = 'zGridDefaultEditor';
                                                finalColumnDef.suppressKeyboardEvent = function (params) {
                                                    const KEY_TAB = 9;
                                                    return params.event.keyCode === KEY_TAB ? false : true;
                                                } ;
                                                break;
                                            default:
                                                finalColumnDef.cellEditor = 'zGridDefaultEditor';
                                                break;
                                        }
                                    }
                                }
                                if(finalColumnDef.cellEditorParams && finalColumnDef.cellEditorParams.zType && finalColumnDef.cellEditorParams.zType === "media"){
                                    finalColumnDef.tooltipField = finalColumnDef.field;
                                }
                            }
                            finalColumnsDefs.push(finalColumnDef) ;

                            if(colDef.width === undefined && colDef.flex === undefined){
                                finalColumnDef.flex = 1 ;
                                finalColumnDef.minWidth = 200 ;
                            }
                        }
                        if(this.editable){
                            finalColumnsDefs = [
                                {
                                    headerName: "",
                                    pinned: "left",
                                    lockPinned: true,
                                    lockPosition: true,
                                    lockVisible: true,
                                    sortable: false,
                                    width: 93,
                                    rowDrag: true,
                                    suppressExcelExport: true,
                                    cellRenderer: (params) =>{
                                        const eDiv = document.createElement('div');
                                        const bt = document.createElement("BUTTON");
                                        bt.type = "button" ;
                                        bt.className = "btn btn-danger btn-sm z-grid-button-delete";
                                        bt.innerHTML = '<i class="fas fa-trash"></i>' ;
                                        eDiv.appendChild(bt) ;

                                        bt.addEventListener('click', ()=> {
                                            this.deleteARecord(params.data) ;
                                        });
                                    
                                        return eDiv;
                                    }
                                }
                            ].concat(finalColumnsDefs) ;
                        }
                        this.dispatchEvent(new CustomEvent("columnsCreated", { detail: finalColumnsDefs})) ;
                    }
                    return upgradeCache().then(()=>{
                        return finalColumnsDefs ; 
                    }) ;
                }) ;
            }

            deleteARecord(data){
                if(this.data){
                    //local datasource
                    const indexData = this.data.indexOf(data) ;
                    if(indexData !== -1){
                        if(this.autoSave){
                            let fieldId = "id" ;
                            if(this.hasAttribute("z-field-id")){
                                fieldId = this.getAttribute("z-field-id") ;
                            }
                            deleteRecord(this, fieldId, indexData) ;
                        }
                        this.data.splice(indexData, 1) ;
                    }
                }else{
                    //server datasource
                    if(this.autoSave){
                        let fieldId = "id" ;
                        if(this.hasAttribute("z-field-id")){
                            fieldId = this.getAttribute("z-field-id") ;
                        }
                        let changes = [] ;
                        let where = {} ; 
                        where[fieldId] = { $in : [] } ;
                        where[fieldId].$in.push(data[fieldId]) ;
                        const model = this.getAttribute("z-model")  ;
                        if(where[fieldId].$in.length > 0){
                            changes.push({
                                table: model,
                                action: "delete",
                                where: where
                            }) ;
                        }
                        
                        let restApi = window.restApi;
                        if(this.hasAttribute("z-app")){
                            restApi = window.getRestApi(this.getAttribute("z-app")) ;
                        }
                        restApi.update(changes).then(()=>{ 
                            if(this.hasAttribute("z-server-side")){
                                this.refreshServerSide() ;
                            }
                        }) ;
                    }
                }
                this.dispatchEvent(new CustomEvent("deleteRow", { detail: data})) ;
            }

            colStateChanged(ev){
                this.dispatchEvent(new CustomEvent("stateChanged", { 
                    bubbles: true, detail: {
                        filter: this.getCurrentFilter(),
                        state: this.gridOptions.columnApi.getColumnState()
                    }
                })) ;
            }

            applyState(state){
                if(this.gridOptions && this.gridOptions.columnApi){
                    this.gridOptions.columnApi.applyColumnState({ state: state });
                }else{
                    this.initialState = state;
                }
            }

            addNewEditRecord(){
                if(this.editable &&  !this.noNewLineAuto){
                    let newRecord = { __isNewLine : true } ;
                    if(this.data){
                        this.data.push(newRecord) ;
                    }else{
                        this.gridOptions.api.setRowCount(this.rowCount + 1);
                        this.gridOptions.api.refreshInfiniteCache();
                    }
                }
            }

            setEditable(editable, autoSave = false){
                let editableChanged = false;
                if(editable !== this.editable){
                    this.editable = editable ;
                    editableChanged = true ;
                }

                if(editable){
                    this.classList.add("z-grid-editing");
                }else{
                    this.classList.remove("z-grid-editing");
                }
                

                if(!editable){
                    if(editableChanged && this.gridOptions && this.gridOptions.api){
                        this.gridOptions.api.stopEditing() ;
                    }
                    setTimeout(()=>{
                        //from editable to not editable, delete last empty line if any
                        if(this.data){
                            for(let i=this.data.length-1; i>=0; i--){
                                const item = this.data[i] ;
                                if(!item.__isNewLine){
                                    break;
                                }
                                this.data.splice(i, 1) ;
                            }
                        }
                    }, 10) ;
                }else{
                    //Go editable, add an empty line at bottom
                    if(this.data){
                        if(this.data.length === 0 || !this.data[this.data.length-1].__isNewLine){
                            this.addNewEditRecord();
                        }
                    }
                }

                setTimeout(()=>{
                    if(autoSave !== this.autoSave){
                        this.autoSave = autoSave ;
                    }
                    
                    if(this.gridOptions){
                        if(editableChanged){
                            this.reInit() ;
                        }
                    }
                }, 10) ;
            }


            onRowDoubleClicked(record){
                const openUrl = this.getAttribute("z-open-url") ;
                if(!openUrl){ return; }
                Mustache.parse(openUrl);
                const url = Mustache.render(openUrl, record); 
                const _globals = this.getRootNode()._globals;
                if(_globals){
                    _globals.context.navigationUrls = [];
                    this.gridOptions.api.forEachNodeAfterFilterAndSort(node=>{
                        const record = node.data ;
                        _globals.context.navigationUrls.push(Mustache.render(openUrl, record));
                    });
                    _globals.context.navigationIndex = _globals.context.navigationUrls.indexOf(url) ;
                }
                window.location.href = url ;
            }

            getDisplayedRecords(){
                var records = [] ;
                this.gridOptions.api.forEachNodeAfterFilterAndSort((node)=>{ 
                    records.push(node.data) ;
                }) ;
                return records ;
            }

            setColumnVisible(field, visible){
                if(this.gridOptions && this.gridOptions.columnApi){
                    var shoudFitColumns = this.shouldFitColumn();
                    this.gridOptions.columnApi.setColumnVisible(field, visible) ;
                    if (shoudFitColumns) {
                        this.gridOptions.api.sizeColumnsToFit();
                    }
                }
            }

            saveColumnState() {
                if(this.gridOptions && this.gridOptions.columnApi){
                    var state = this.gridOptions.columnApi.getColumnState() ;
                    localStorage.setItem("z-grid-state-"+this.id, JSON.stringify(state)) ;
                }
            }

            getCurrentFilter(){
                return {
                    quick: this.gridOptions.api.filterManager.quickFilter,
                    model: this.gridOptions.api.getFilterModel()
                } ;
            }

            applyFilter(filter){
                if(this.gridOptions && this.gridOptions.api){
                    this.gridOptions.api.setQuickFilter(filter.quick);
                    this.gridOptions.api.setFilterModel(filter.model) ;
                    this.gridOptions.api.redrawRows(); //force redraw for search highlight
                }else{
                    this.initialFilter = filter;
                }
            }

            setQuickFilter(filter){
                this.gridOptions.api.setQuickFilter(filter);
			    this.gridOptions.api.redrawRows(); //force redraw for search highlight
            }

            resetColumnState() {
                var shoudFitColumns = this.shouldFitColumn();
                this.gridOptions.columnApi.resetColumnState() ;
                localStorage.removeItem("z-grid-state-"+this.id) ;
                if (shoudFitColumns) {
                    this.gridOptions.api.sizeColumnsToFit();
                }
            }

            shouldFitColumn(){
                //for ag-grid >= 25.3.0
                var availableWidth = this.gridOptions.api.gridBodyComp.eBodyViewport.querySelector(".ag-full-width-container").offsetWidth ;
                var columns = this.gridOptions.columnApi.getAllDisplayedColumns() ;
                var usedWidth = this.gridOptions.columnApi.columnController.getWidthOfColsInList(columns);
               /*for ag-grid = 25.1.0
                var availableWidth = this.gridOptions.api.gridBodyComp.eBodyViewport.querySelector(".ag-full-width-container").offsetWidth ;
                var columns = this.gridOptions.columnApi.getAllDisplayedColumns() ;
                var usedWidth = this.gridOptions.columnApi.columnController.getWidthOfColsInList(columns);
                */
                return usedWidth <= availableWidth ;
            }

            onGridEvent(event, callback){
                if(!this.listeners){
                    this.listeners = {} ;
                }
                if(!this.listeners[event]){
                    this.listeners[event] = [] ;
                }
                this.listeners[event].push(callback) ;
                if(this.gridOptions && this.gridOptions.api){
                    this.gridOptions.api.addEventListener(event, callback);
                }
            }

            fitColumnIfNeeded(){
                if (this.shouldFitColumn()) {
                    this.gridOptions.api.sizeColumnsToFit();
                }
            }

            reInit(){
                if(!this.parentElement){ return ;}
                if(!this.getRootNode().getData) { return ; /* has been disconnected, don't try to reinit */}
                this.initDone = false;
                this.init() ;
            }


            notifyChange(){
                if(this.changeTimeout){
                    clearTimeout(this.changeTimeout) ;
                }
                this.changeTimeout = setTimeout(()=>{
                    this.doNotifyChange() ;
                }, 1) ;
            }

            doNotifyChange(){
                // console.log("NOTIFY CHANGE IN GRID", this.data) ;

                //we are notify that something may have changed inside the data array
                if(this.gridOptions && this.gridOptions.api){
                    const rowNodes = this.gridOptions.api.getModel().nodeManager.allNodesMap ;
                    //rowNodes is not an array but a {0:..., 1: ...}. When we remove a row, it has "holes"
                    const rowNodeKeys = Object.keys(rowNodes).sort((a,b)=>Number(a)-Number(b)) ; 
                    let keysToVisit = {} ;
                    for(let k of rowNodeKeys){
                        keysToVisit[k] = true ;
                    }
                    // console.log("ROW NODE", keysToVisit, rowNodes) ;
                    let indexGrid = 0;
                    let shouldRefreshCell = false ;
                    let refreshTr = {
                        add: [],
                        remove: [],
                        update: []
                    } ;
                    let transactions = [refreshTr] ;
                    for(let indexData = 0; indexData<this.data.length; indexData++){
                        const itemData = this.data[indexData] ;
                        const rowKey = rowNodeKeys[indexGrid] ;
                        let rowNode = null;
                        if(rowKey){
                            rowNode = rowNodes[rowKey] ;
                            // console.log("VIEW ", rowKey) ;
                            delete keysToVisit[rowKey] ;
                        }
                        // console.log("CHECK data["+indexData+"] VS grid["+indexGrid+"]", 
                        //     JSON.parse(JSON.stringify(itemData)), 
                        //     (rowNode?JSON.parse(JSON.stringify(rowNode.data)):"null")) ;
                        if(rowNode && itemData === rowNode.data){
                            //the row node already exist in the table at the expected position
                            // console.log("SAME, refresh",JSON.parse(JSON.stringify(rowNode.data)), JSON.parse(JSON.stringify(itemData))) ;
                            shouldRefreshCell = true ;
                            indexGrid++; //go to next row node
                        }else if(rowNode && itemData !== rowNode.data){
                            //at this position the row node data is not the table data. So the row node does not exist yet
                            //in the table, we must remove it
                            // console.log("must REMOVE ") ;
                            refreshTr.remove.push(rowNode.data) ;
                            //this.gridOptions.api.updateRowData({ remove: [rowNode.data] });
                            //stay at the same place in table to check next row 
                            indexData--;
                            indexGrid++;//go to check next row node
                        }else if(!rowNode){
                            //no row node found at this position, we must add one
                            // console.log("must ADD ",JSON.parse(JSON.stringify(itemData))) ;
                            if(refreshTr.addIndex !== undefined && refreshTr.addIndex !== indexData - refreshTr.length){
                                refreshTr = {
                                    add: [],
                                    remove: [],
                                    update: []
                                } ;
                                transactions.push(refreshTr) ;
                            }
                            refreshTr.add.push(itemData) ;
                            refreshTr.addIndex = indexData ;
                            // this.gridOptions.api.updateRowData({ add: [itemData], addIndex: indexData });

                            indexGrid++; //go to next row node
                        }
                    }
                    // console.log("REMAIN TO VISIT ?", keysToVisit) ;
                    const remainingKeys = Object.keys(keysToVisit) ; 
                    for(let rowKey of remainingKeys){
                        //some node row has not been seen in data so they must be deleted
                        const rowNode = rowNodes[rowKey] ;
                        refreshTr.remove.push(rowNode.data) ;
                        // this.gridOptions.api.updateRowData({ remove: [rowNode.data] });
                    }

                    for(let tr of transactions){
                        if(tr.add.length > 0 || tr.remove.length > 0 || tr.update.length > 0){
                            this.gridOptions.api.applyTransactionAsync(tr) ;
                        }
                    }
                    
                    if(shouldRefreshCell){
                        this.gridOptions.api.refreshCells() ;
                    }
                }
            }

            get noNewLineAuto(){
                return this.hasAttribute("z-no-new-line-auto");
            }

            set noNewLineAuto(noNewLineAuto){
                if(noNewLineAuto){
                    this.setAttribute("z-no-new-line-auto", "true");
                }else{
                    this.removeAttribute("z-no-new-line-auto");
                }
            }

            get editable(){
                return this.hasAttribute("z-editable");
            }

            set editable(editable){
                let editableChanged = false ;
                if(editable !== this.editable){
                    editableChanged = true ;
                }
                if(editable){
                    this.setAttribute("z-editable", "true");
                }else{
                    this.removeAttribute("z-editable");
                }
                if(editableChanged){
                    this.reInit() ;
                }
            }
            
            get autoSave(){
                return this.hasAttribute("z-auto-save") || this.hasAttribute("auto-save");
            }

            set autoSave(autoSave){
                if(autoSave){
                    this.setAttribute("auto-save", "true");
                    this.setAttribute("z-auto-save", "true");
                }else{
                    this.removeAttribute("auto-save");
                    this.removeAttribute("z-auto-save");
                }
            }

            get value() {
                return this.data ;
            }

            set value(value) {
                
                this.data = value;
                if(this.gridOptions && this.gridOptions.api){
                    this.gridOptions.api.setRowData(value);
                    var selectedNodes = this.gridOptions.api.getSelectedNodes() ;
                    selectedNodes.forEach((node)=>{
                        var newNode = this.gridOptions.api.getRowNode(node.id) ;
                        if(newNode){
                            newNode.setSelected(true);
                        }
                    }) ;
                }
                if(this.data.length === 0 || !this.data[this.data.length-1].__isNewLine){
                    this.addNewEditRecord();
                }
            }

            getXlsData(){
                var sheet = {
                    lines: []
                };
                var state = this.gridOptions.columnApi.getColumnState().filter(function(s){
                    return !s.hide ;
                }) ;
                sheet.colsWidth = state.map(function(col, i){
                    return { column: i, width: col.width/10 } ;
                }) ;
                var count = this.gridOptions.api.getDisplayedRowCount();
                sheet.lines.push([ {value: moment().format("YYYY-MM-DD HH:mm:ss.SSS"), type: "date", style: {numberFormat : "dd/mm/yyyy hh:mm"}} ]) ;
                sheet.lines.push([]);
                sheet.lines.push([ {
                    value: tr("grid.lineCount"), 
                    colspan: state.length-1,
                    style: {alignment: {horizontal: "right"}}
                },  count]) ;
                
                var colDefsById = {};
                for (let i = 0; i<this.gridOptions.columnDefs.length; i++) {
                    colDefsById[this.gridOptions.columnDefs[i].colId] = this.gridOptions.columnDefs[i] ;
                }
                var lineHeader = [] ;
                for(let y=0; y<state.length; y++){
                    var colDef = colDefsById[state[y].colId];
                    if(!colDef || colDef.suppressExcelExport){ continue ; }
                    lineHeader.push({ 
                        value: colDef&&colDef.headerName?colDef.headerName.replace(/<[^>]*>/g, ""):"", 
                        style: {
                            font: { bold: true },
                            border: {
                                left: { style: "thin" },
                                right: { style: "thin" },
                                top: { style: "thin" },
                                bottom: { style: "thin" },
                            }
                        }
                    }) ;
                }
                sheet.lines.push(lineHeader);
                for (let i = 0; i<count; i++) {
                    let line = [] ;
                    sheet.lines.push(line) ;
                    let rowNode = this.gridOptions.api.getDisplayedRowAtIndex(i);
                    let data = rowNode.data;
                    if(!data && rowNode.group){
                        data = JSON.parse(JSON.stringify(rowNode.aggData)) ;
                        data[rowNode.field] = rowNode.groupData["ag-Grid-AutoColumn"] ;
                        colDefsById["ag-Grid-AutoColumn"] = colDefsById[rowNode.field] ;
                    }
                    if(!data){ continue ;}
                    if(data.__isNewLine){ continue ;}
                    for(let y=0; y<state.length; y++){
                        let colDef = colDefsById[state[y].colId];
                        if(!colDef || colDef.suppressExcelExport){ continue ; }
                        let value = "";
                        if(state[y].colId){
                            let dataObj = data ;
                            state[y].colId.split(".").forEach(k=>{
                                if(dataObj){
                                    value = dataObj[k] ;
                                    dataObj = value ;
                                }else{
                                    value = "" ;
                                }
                            }) ;
                        }
                        //let value = data[state[y].colId] ;
                        let style = {
                            border: {
                                left: { style: "thin" },
                                right: { style: "thin" },
                                top: { style: "thin" },
                                bottom: { style: "thin" },
                            }
                        };
                        let type = "string";
                        if(colDef){
                            let fieldType = "";
                            if(colDef.cellEditorParams){
                                fieldType = colDef.cellEditorParams.zType;
                            }else if(colDef.type === "numericColumn"){
                                fieldType = "numeric" ;
                            }
                            if(fieldType==="numeric" || fieldType==="decimal" || 
                                fieldType==="double" || fieldType==="float" || fieldType==="float8" 
                                || fieldType==="percent" || fieldType==="currency"){
                                type = "number" ;
                                value = Number(data[state[y].colId]) ;
                                style.numberFormat = "#,##0.00;(#,##0.00)";
                            } else if(fieldType === "int" || fieldType === "integer" || fieldType==="percentint" || fieldType==="sequence"){
                                type = "number" ;
                                value = Number(data[state[y].colId]) ;
                                style.numberFormat = "#,##0 ;(#,##0)";
                            } else if(fieldType === "date"){
                                if(value){ 
                                    type = "date";
                                    value = moment(data[state[y].colId]).format("YYYY-MM-DD") ;
                                }
                            } else if(fieldType === "datetime" || fieldType === "timestamp"){
                                if(value){ 
                                    type = "date";
                                    value = moment(data[state[y].colId]).format("YYYY-MM-DD HH:mm:ss.SSS") ;
                                    style.numberFormat = "dd/mm/yyyy hh:mm";
                                }
                            } else if(fieldType === "textarea" || fieldType === "email" || fieldType === "icon"){
                                type = "string" ;
                            } else if(fieldType === "checkbox" || fieldType === "boolean"){
                                type = "string" ;
                                value = value?tr("global.yes"):tr("global.no") ;
                            } else if(fieldType === "code-html" || fieldType === "compose-html"){
                                type = "string" ;
                                const divRender = document.createElement("DIV") ;
                                divRender.innerHTML = colDef.valueFormatter({value: value, node: {rowHeight: 40}}) ;
                                value = Array.prototype.filter.call(divRender.children, t=>{ return t.tagName !== "SCRIPT" && t.tagName !== "STYLE" ; }).map(t=>t.innerText).join(" ") ;
                            } else if(fieldType === "binary" || fieldType === "media"){
                                type = "string" ;
                                if(value && value.filename){
                                    value = value.filename ;
                                }else{
                                    value = "" ;
                                }
                            }else if(colDef.valueFormatter){
                                value = colDef.valueFormatter({value: value, node: {rowHeight: 40}}) ;
                            }else {
                                value = ""+value;
                            }
                        }
                        
                        line.push({
                            value: value,
                            type: type,
                            style: style
                        }) ;
                    }
                }
            return sheet ;
            }


            static get observedAttributes() {
                return ["z-auto-save","auto-save", "z-col-def", "z-app"];
            }
    
            attributeChangedCallback(name, oldValue, newValue) {
                switch (name) {
                    // case 'z-editable':
                    //     this.setEditable(this.editable, this.autoSave) ;
                    //     break;
                    case 'auto-save':
                    case 'z-auto-save':
                        this.setEditable(this.editable, this.autoSave) ;
                        break;
                    case 'z-col-def':
                        if(oldValue !== newValue){
                            this.reInit() ;
                        }
                        break;
                    case 'z-app':
                        if(oldValue !== newValue){
                            this.reInit() ;
                        }
                        break;
                }
            }
    
        }
        customElements.define(COMPONENT_NAME, GridComponent);
        customElements.define("z-col", GridColComponent);
        customElements.define("z-mobile-render", GridMobileRenderComponent);
    }).catch((err)=>{
        throw err ;
    }) ;
}

